import { createGlobalStyle } from 'styled-components'

import { media, mediaMax } from './media'

/* eslint-disable */
export default createGlobalStyle`
  body {
    color: #333;
    font-size: 16px;
    font-family: 'GT Walsheim Pro', 'Helvetica Neue', Helvetica, Arial, sans-serif !important;
    font-weight: 300 !important;
    letter-spacing: 0.25px;
  }

  input,
  button,
  select,
  textarea {
    letter-spacing: 0.25px;
  }

  img {
    max-width: 100%;
  }

  .grecaptcha-badge { visibility: hidden; }

  b, strong {
    font-weight: 500;
  }

  .container {
    max-width: 100%;
  }

  .tether-element {
    z-index: 1;
  }

  .player .vp-player-layout {
    top: auto !important;
    height: 100% !important;
  }

  .ReactModalPortal {
    position: relative;
    z-index: 10000;
  }

  .ReactModal__Body {}

  .ReactModal__Body--open {
    .alerts {
      display: none;
    }

    overflow: hidden;
  }

  .ReactModal__Content {
    outline: 0;

    ${media.sm`
      &.rounded {
        border-radius: 8px;
      }

      &.extra-rounded {
        border-radius: 16px;
      }

      &.extra-rounded-top-only {
        border-top-left-radius: 16px;
        border-top-right-radius: 16px;
      }
    `}

    &.bottom-align {
      margin-top: auto;
    }

    &.half-screen-max {
      height: auto;
      max-height: 50vh;
    }

    &.rounded-top {
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
    }
  }

  .c-basic-modal__content {
    box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.039), 0px 5.5px 16px rgba(0, 0, 0, 0.19);
    position: static;
    margin: 0 auto;

    &:not(.auto-width) {
      width: 100%;
      max-width: 640px;
    }

    max-height: 100%;

    border: none !important;
    padding: 0 !important;

    background-color: white;
    overflow-y: auto;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;

    ${mediaMax.md`
      height: 100%;
      width: 100%;
    `}

    ${media.sm`
        max-height: 90vh;
    `}

    &.narrow {
      max-width: 520px;
    }

    &.wide {
      max-width: 800px;
    }

    &.mobile-centered {
      ${mediaMax.md`
        margin: auto 30px;
      `}
    }
  }

  .c-fullscreen-modal__content {
    width: 100%;
    height: 100%;
    overflow: auto;
    margin: 0 auto;
  }
  .c-fullscreen-modal__content.white {
    background-color: white;
  }

  .c-basic-modal__overlay {
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    background-color: rgba(255, 255, 255, 0.75);

    display: flex;
    align-items: flex-start;
    justify-content: space-around;
      align-items: center;

    background-color: rgba(0, 0, 0, 0.3) !important;
  }

  .c-fullscreen-modal__overlay {
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    background-color: rgba(29, 29, 29, 0.9);
    z-index: 999;
    -webkit-overflow-scrolling: touch;
  }
  .c-fullscreen-modal__overlay.light {
    background-color: rgba(29, 29, 29, 0.3);
  }
  .c-fullscreen-modal__overlay.no-darken {
    background-color: transparent !important;
  }

  .uppy-Root {
    font-family: inherit !important;
  }
  .uppy-Dashboard-browse {
    color: #0c6776 !important;
  }

  .SingleDatePicker_picker__portal,
  .DateRangePicker_picker__portal {
    z-index: 10000;
  }

  .DateInput {
    width: auto;
  }

  .pac-container {
    z-index: 100000 !important;
  }
`
/* eslint-enable */
